import { SavingsProfile } from "../../../types/SavingsProfile";
import Segment from "../../common/Segment";
import FeeDetailsTable from "../../common/fee-details/FeeDetailsTable";
import useApplicationStore from "../../../state/ApplicationStore";
import DynamicText from "../../common/DynamicText";
import useTextStore from "../../../state/TextStore";
import RiskView from "./riskview/RiskView";
import SavingsProfileInformationTable from "./SavingsProfileInformationTable";
import { Button, Link } from "frno-react";

type ExpandedSavingsProfileRowProps = {
  savingsProfile: SavingsProfile;
};
export default function ExpandedSavingsProfileRow({
  savingsProfile,
}: ExpandedSavingsProfileRowProps) {
  const pensionProduct = savingsProfile.pensionProducts[0];
  const { savingsValue } = useApplicationStore();
  const { getTextByKey } = useTextStore();

  return (
    <>
      <RiskView currentRisk={savingsProfile.riskClass} maxRisk={7} />

      <Segment
        headerKey="page.savingsprofiles.table.expandedrow.riskinformation.header"
        headerVariable={savingsProfile.riskClass}
        mainContent={
          <DynamicText
            textKey="page.savingsprofiles.table.expandedrow.riskinformation.content"
            replaceComponent={
              <Link
                href="https://www.forbrukerradet.no/sparing-i-fond-og-spareprofiler"
                target="_blank"
                linkText={getTextByKey(
                  "page.savingsprofiles.table.expandedrow.riskinformation.linktext",
                )}
              />
            }
          />
        }
      />

      <SavingsProfileInformationTable savingsProfile={savingsProfile} />

      <Segment
        headerKey="page.savingsprofiles.table.expandedrow.profileinfo.referenceindex"
        mainContent={savingsProfile.referenceIndex}
      />

      <FeeDetailsTable
        headerKey="page.companies.table.expandedrow.feedetails.header"
        computedFees={savingsProfile.activePensionProduct.computedFees}
        savingsValue={savingsValue}
      />
      {pensionProduct && pensionProduct.fees.feeDescription && (
        <Segment
          headerKey="page.companies.table.expandedrow.feedescription.header"
          mainContent={pensionProduct.fees.feeDescription}
        />
      )}
      {pensionProduct && pensionProduct.setupFeeDescription && (
        <Segment
          headerKey="page.companies.table.expandedrow.setupfeedescription.header"
          mainContent={pensionProduct.setupFeeDescription}
        />
      )}
      {pensionProduct && (
        <div className="flex flex-wrap gap-5 mt-8">
          <Button
            href={pensionProduct.url}
            className="btn-featured"
            icon="fa-arrow-up-right-from-square"
            target="_blank"
          >
            <DynamicText
              textKey="page.companies.table.expandedrow.button.company"
              replaceComponent={pensionProduct.company.name}
            />
          </Button>
        </div>
      )}
    </>
  );
}
